import React, { useEffect, useState } from "react";
import AwsAxios from "../../utils/AwsAxios";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  CheckCircleFilled,
  CheckOutlined,
  CompressOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import GradientButton from "../Button/GradientButton";
import LoadingCom from "../LoadingCom";
import { formatLastModified } from "../../utils/TimeConvert";
import { ConfigProvider, Popover, Steps } from "antd";

const SubmittedIdeaDetail = () => {
  const { Id } = useParams();
  const [projectDetail, setProjectDetail] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [image, setImage] = useState("");

  console.log(state.data, "idddddddddddddd");

  const fetchImageApi = async (image) => {
    try {
      const parts = image?.split("/resources/");
      const imageId = parts[1];
      console.log(imageId, "Response fetch imagessss");
      const response = await AwsAxios.get(
        `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/image/${imageId}`
      );

      console.log(response.data, "Response fetch imagessss");
      return `data:image/jpeg;base64,${response.data}`;
    } catch (error) {
      console.error("Error fetching image:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AwsAxios.get(
          `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/details/${Id}`
        );
        const projectData = response.data.data;

        const desiredFields = [
          "Campaign / Channel",
          "Idea Description",
          "Creator of Idea",
          "Contributor(s)",
          "Submitted",
          "Comments",
        ];

        const extractedDataObject = projectData?.fields?.reduce((acc, obj) => {
          if (desiredFields.includes(obj.caption)) {
            acc[obj.caption] = obj;
          }
          return acc;
        }, {});

        if (extractedDataObject["Campaign / Channel"]) {
          const image = await fetchImageApi(
            extractedDataObject["Campaign / Channel"].objects[0].image
          );
          setImage(image);
        }
        console.log({ extractedDataObject });
        setProjectDetail({ ...projectData, extractedDataObject });
      } catch (error) {
        console.error("Error fetching project details:", error);
      }
    };

    fetchData();
  }, [Id]);

  console.log({ image });

  const desiredFields = [
    "Campaign / Channel",
    "Idea Description",
    "Creator of Idea",
    "Contributor(s)",
    "Submitted",
    "Comments",
  ];
  // const extractedDataObject = projectDetail?.fields?.reduce((acc, obj) => {
  //   if (desiredFields.includes(obj.caption)) {
  //     console.log(desiredFields.includes(obj.caption), "caption getting");
  //     if (obj?.caption == "Campaign / Channel") {
  //       const image = fetchImageApi(obj.objects[0].image);
  //       console.log("helooowowowo", image);
  //     }
  //     acc[obj.caption] = obj;
  //     // if (acc[obj.caption] && acc[obj.type == "textField"]) {
  //     // }
  //     // acc[obj.caption] = obj.imageField;
  //   }
  //   return acc;
  // }, {});

  const Status = projectDetail?.statuses[0]?.value;

  const currentStepIndex =
    Status === "Draft"
      ? 0
      : Status === "Community Discussion"
      ? 1
      : Status === "HOT!"
      ? 2
      : Status === "Evaluation"
      ? 3
      : Status === "Selected"
      ? 4
      : 0;

  console.log({ Status });
  console.log({ currentStepIndex });
  // console.log({ extractedDataObject });
  console.log({ projectDetail });

  // const imageExtract = projectDetail.fields.find(
  //   (val) => val.caption === "Banner"
  // );

  // useEffect(() => {
  //   try {
  //     AwsAxios.get(
  //       `https://7q63conwve.execute-api.us-east-2.amazonaws.com/Prod/hype/image/e279958efc9940ae15aa45ce2293158f`
  //     )
  //       .then((res) => {
  //         console.log(res, "response from project image");
  //         // setProjectDetail(res.data.data);
  //         setImage(res.data.data)
  //       })
  //       .catch((err) => console.log(err));
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // }, []);

  // const image =
  //   extractedDataObject &&
  //   extractedDataObject["Campaign / Channel"]?.objects[0]?.image;
  // console.log(image, "imagesssssssssssss");
  return (
    <ConfigProvider
      theme={{
        token: {
          /* here is your global tokens */
          colorPrimary: "#FF6B38",
        },
      }}
    >
      {projectDetail ? (
        <div className="bg-pureWhite rounded-2xl items-center p-4 courses_Style">
          <div
            className="w-fit flex items-center gap-x-2 cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <LeftOutlined style={{ color: "#8F8F8F", fontSize: 18 }} />
            <p className="text-[#8F8F8F] text-sm">Back to projects</p>
          </div>
          <div className="mt-7 flex flex-col lg:flex-row items-center justify-between ">
            <div className="flex gap-4 items-center mb-2 w-[70%]">
              <div className="rounded-2xl">
                <img
                  src={`${image}`}
                  alt="Course Main Image"
                  className=" h-32 border-2 rounded-2xl"
                  width={200}
                  height={200}
                />
              </div>
              <div>
                <p className="text-2xl lg:text-3xl font-semibold font-bizmo text-black">
                  {projectDetail?.title}
                </p>
                <p className="text-sm  font-bizmo text-[#8F8F8F]">
                  Idea Created by{" "}
                  {
                    projectDetail.extractedDataObject["Creator of Idea"]
                      ?.users[0]?.value
                  }
                </p>
              </div>
            </div>
            <div className="flex flex-col justify-center items-center lg:items-center lg:justify-center">
              <GradientButton>
                <Link target="_" to={state?.data?.webUrl}>
                  Visit Idea
                </Link>
              </GradientButton>
              <p className="text-xs lg:text-sm text-[#8F8F8F] mt-2">
                Last Modified:
                {formatLastModified(projectDetail?.lastChange)}
              </p>
            </div>
          </div>
          <div className="mt-12">
            <Steps
              current={currentStepIndex}
              size="small"
              responsive
              progressDot
              items={[
                {
                  title: "Draft",
                },
                {
                  title: "Community Discussion",
                },
                {
                  title: "HOT!",
                },
                {
                  title: "Evaluation",
                },
                {
                  title: "Selected",
                },
              ]}
            />
          </div>
          <div className="mt-10 p-5">
            <div>
              <p className="text-lg font-bold">Participants</p>
              <ul className="list-disc px-2 font-normal text-[#8F8F8F]">
                {projectDetail.extractedDataObject[
                  "Contributor(s)"
                ]?.users?.map((val, i) => (
                  <li key={i}>{val?.value}</li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-lg font-bold">Description</p>
              <div
                className="px-2 text-[#8F8F8F]"
                dangerouslySetInnerHTML={{
                  __html:
                    projectDetail.extractedDataObject["Idea Description"]?.text,
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <LoadingCom />
      )}
    </ConfigProvider>
  );
};

export default SubmittedIdeaDetail;

// [
//     {
//       title: "Draft",
//     },
//     {
//       title: "Community Discussion",
//     },
//     {
//       title: "HOT!",
//     },
//     {
//       title: "Evaluation",
//     },
//     {
//       title: "Selected",
//     },
//   ]
